export enum LoadingStatus {
  NONE = 'none',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}
